import React from 'react';
import { Container, Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import WebsiteLayout from '../../components/Website/WebsiteLayout';
import HeroSection from '../../components/Website/HeroSection';
import SEO from '../../components/SEO/SEO';

const CookiePolicyPage = () => {
    return (
        <WebsiteLayout>
            <SEO title="Cookie Policy - Flux IT Studio" description="Cookie policy for Flux ERP" />
            <HeroSection>
                <Box sx={{ textAlign: 'center', maxWidth: 800, mx: 'auto' }}>
                    <Typography variant="h1" sx={{ fontSize: { xs: 40, md: 56 }, fontWeight: 800, mb: 3, color: 'primary.contrastText' }}>
                        Cookie Policy
                    </Typography>
                    <Typography variant="h6" sx={{ opacity: 0.95, color: 'primary.contrastText' }}>
                        How we use cookies to improve your experience
                    </Typography>
                </Box>
            </HeroSection>

            <Container maxWidth="md" sx={{ py: 8 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>1. What are Cookies?</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>2. How We Use Cookies</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    Flux IT Studio LTD uses cookies for several reasons:
                </Typography>
                <Box component="ul" sx={{ color: 'text.secondary', mb: 4 }}>
                    <li><strong>Essential Cookies:</strong> Necessary for the operation of our platform (e.g., login, security).</li>
                    <li><strong>Performance Cookies:</strong> Allow us to count visits and traffic sources so we can measure and improve the performance of our site.</li>
                    <li><strong>Functional Cookies:</strong> Enable the website to provide enhanced functionality and personalization.</li>
                    <li><strong>Targeting Cookies:</strong> May be set through our site by our advertising partners to build a profile of your interests.</li>
                </Box>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>3. Cookies We Use</Typography>
                <TableContainer component={Paper} elevation={0} sx={{ border: 1, borderColor: 'divider', mb: 4 }}>
                    <Table>
                        <TableHead sx={{ bgcolor: 'background.neutral' }}>
                            <TableRow>
                                <TableCell><strong>Cookie Name</strong></TableCell>
                                <TableCell><strong>Purpose</strong></TableCell>
                                <TableCell><strong>Duration</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>token</TableCell>
                                <TableCell>Authentication and session management</TableCell>
                                <TableCell>30 Minutes</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>refreshToken</TableCell>
                                <TableCell>Secure token refresh</TableCell>
                                <TableCell>7 Days</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>cookieConsent</TableCell>
                                <TableCell>Stores your cookie preferences</TableCell>
                                <TableCell>1 Year</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>4. Managing Cookies</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    You can manage your cookie preferences at any time by clicking the "Cookie Settings" button in the footer of our website. Please note that disabling essential cookies may affect the functionality of Flux ERP.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>5. Updates to This Policy</Typography>
                <Typography variant="body1" color="text.secondary">
                    We may update this Cookie Policy from time to time. The "Last Updated" date at the top of the Privacy Policy reflects the latest changes across our legal documentation.
                </Typography>
            </Container>
        </WebsiteLayout>
    );
};

export default CookiePolicyPage;
